import { MultiSelectionAnswer } from 'views/pages/compatibilityCheck/hooks';
import { CommonData } from 'views/templates/module/common';

//関係性のあれこれ
//リスト名
export enum RelastionShip {
  Half = '50%超の議決権または50％超の配当・分配を受ける権利を保有（こちらに該当する実質的支配者を申告した場合、実質的支配者②・③の申告は不要です）',
  Quarter = '25%超50%以下の議決権または25%超50%以下の配当・分配を受ける権利を保有（複数名の該当がある場合、実質的支配者②・③を使って全員について申告ください）',
  JigyoKatsudo = '出資・融資・取引その他の関係を通じて事業活動に支配的な影響力を有する',
  Daihyosya = '法人を代表し、その業務を執行している（上記いずれにも該当がない場合にのみ選択してください）',
}

//{ id: number; value: string }[]のデータ作る
export const RelastionShipList: CommonData[] = (Object.keys(RelastionShip) as (keyof typeof RelastionShip)[]).map(
  (key, index) => {
    return { id: index + 1, value: RelastionShip[key] };
  },
);
//string[]のデータ作る
export const RelastionShipStrs = RelastionShipList.map((data) => data.value);
export const findRelastionShipId = (str: string) => RelastionShipList.find((data) => data.value === str)?.id;
export const findRelastionShipName = (index: number) => RelastionShipList.find((data) => data.id === index)?.value;

export enum ContactCategory {
  Shiryoseikyu = '当社資料請求',
  AboutService = 'サービスに関するお問い合わせ',
  Other = 'その他、ご意見ご感想など',
}

export const ContactCategoryList: CommonData[] = (Object.keys(ContactCategory) as (keyof typeof ContactCategory)[]).map(
  (key, index) => ({ id: index + 1, value: ContactCategory[key] }),
);

export const ContactCategoryStrs = ContactCategoryList.map((data) => data.value);
export const findContactCategoryId = (str: string) => ContactCategoryList.find((data) => data.value === str)?.id;
export const findContactCategoryName = (index: number) => ContactCategoryList.find((data) => data.id === index)?.value;

//業種のあれこれ
//リスト名
export enum CorporateBusinessContent {
  KensetsuGyo = '建設業',
  SeizouGyo = '製造業',
  JyohoTsushinGyo = '情報通信業',
  UnyuGyo = '運輸業',
  OroshiUriKouriGyo = '卸売業・小売業',
  FudousanBuppinChintaiGyo = '不動産業・物品賃貸業',
  SenmonGijyutuServiceGyo = '専門・技術サービス業',
  ShukuhakuInshokuServiceGyo = '宿泊業・飲食サービス業',
  SeikatukanrenServiceGorakuGyo = '生活関連サービス業・娯楽業',
  KyouikuGakushusienGyo = '教育・学習支援業',
  IryoFukushi = '医療・福祉',
  Service = 'サービス業(他に分類されないもの)',
  Sonohoka = 'その他',
}

//{ id: number; value: string }[]のデータ作る
const CorporateBusinessContentList: CommonData[] = (
  Object.keys(CorporateBusinessContent) as (keyof typeof CorporateBusinessContent)[]
).map((key, index) => {
  return { id: index + 1, value: CorporateBusinessContent[key] };
});
//string[]のデータ作る
export const CorporateBusinessContentStrs = CorporateBusinessContentList.map((data) => data.value);
export const findCorporateBusinessContentId = (str: string) =>
  CorporateBusinessContentList.find((data) => data.value === str)?.id;
export const findCorporateBusinessContentName = (index: number) =>
  CorporateBusinessContentList.find((data) => data.id === index)?.value;

//業種のあれこれ
//リスト名
export enum PersonalBusinessContent {
  KensetsuGyo = '建設業',
  SeizouGyo = '製造業',
  JyohoTsushinGyo = '情報通信業',
  UnyuGyo = '運輸業',
  OroshiUriKouriGyo = '卸売業・小売業',
  FudousanBuppinChintaiGyo = '不動産業・物品賃貸業',
  SenmonGijyutuServiceGyo = '専門・技術サービス業',
  ShukuhakuInshokuServiceGyo = '宿泊業・飲食サービス業',
  SeikatukanrenServiceGorakuGyo = '生活関連サービス業・娯楽業',
  KyouikuGakushusienGyo = '教育・学習支援業',
  IryoFukushi = '医療・福祉',
  ISHI = '医師',
  ZeirishiKouninkaikeishiNado = '税理士/公認会計士/弁護士/司法書士/行政書士',
  Service = 'サービス業(他に分類されないもの)',
  Sonohoka = 'その他',
}

//{ id: number; value: string }[]のデータ作る
const PersonalBusinessContentList: CommonData[] = (
  Object.keys(PersonalBusinessContent) as (keyof typeof PersonalBusinessContent)[]
).map((key, index) => {
  return { id: index + 1, value: PersonalBusinessContent[key] };
});
//string[]のデータ作る
export const PersonalBusinessContentStrs = PersonalBusinessContentList.map((data) => data.value);
export const findPersonalBusinessContentId = (str: string) =>
  PersonalBusinessContentList.find((data) => data.value === str)?.id;
export const findPersonalBusinessContentName = (index: number) =>
  PersonalBusinessContentList.find((data) => data.id === index)?.value;

export enum IntroducerContent {
  Kinyukikan = '金融機関',
  zeirishikouninkaikeishi = '税理士・公認会計士',
  sonota = 'その他',
}

const IntroducerContentList: CommonData[] = (Object.keys(IntroducerContent) as (keyof typeof IntroducerContent)[]).map(
  (key, index) => {
    return { id: index + 1, value: IntroducerContent[key] };
  },
);
//string[]のデータ作る
export const IntroducerContentStrs = IntroducerContentList.map((data) => data.value);

//投資目的あれこれ
//リスト名
export enum AssetTransactionPurpose {
  LeaseFund = '日本型オペレーティング・リース案件',
  DomesticRealEstate = '不動産小口化商品',
  OverseasRealEstate = '海外不動産案件',
}
//{ id: number; value: string }[]のデータ作る
const AssetTransactionPurposeList: CommonData[] = (
  Object.keys(AssetTransactionPurpose) as (keyof typeof AssetTransactionPurpose)[]
).map((key, index) => {
  return { id: index + 1, value: AssetTransactionPurpose[key] };
});
//string[]のデータ作る
export const AssetTransactionPurposeStrs = AssetTransactionPurposeList.map((data) => data.value);
export const findAssetTransactionPurposeId = (str: string) =>
  AssetTransactionPurposeList.find((data) => data.value === str)?.id;
export const findAssetTransactionPurposeName = (index: number) =>
  AssetTransactionPurposeList.find((data) => data.id === index)?.value;

//投資目的あれこれ
//リスト名
export enum LeaseFundPurpose {
  ZaimuSenryaku = '財務戦略',
  ShikinUnyo = '資金運用',
  Other = 'その他',
}
//{ id: number; value: string }[]のデータ作る
const CorporateLeaseFundPurposeList: CommonData[] = (Object.keys(LeaseFundPurpose) as (keyof typeof LeaseFundPurpose)[]).map(
  (key, index) => {
    return { id: index + 1, value: LeaseFundPurpose[key] };
  },
);
//string[]のデータ作る
export const CorporateLeaseFundPurposeStrs = CorporateLeaseFundPurposeList.map((data) => data.value);
export const findCorporateLeaseFundPurposeId = (str: string) => CorporateLeaseFundPurposeList.find((data) => data.value === str)?.id;
export const findCorporateLeaseFundPurposeName = (index: number) =>
  CorporateLeaseFundPurposeList.find((data) => data.id === index)?.value;

export enum CorporateOverseasRealEstatePurpose {
  ShisanHozen = '資産保全',
  ShisanUnyo = '資産運用',
  Other = 'その他',
}
//{ id: number; value: string }[]のデータ作る
const CorporateOverseasRealEstatePurposeList: CommonData[] = (
  Object.keys(CorporateOverseasRealEstatePurpose) as (keyof typeof CorporateOverseasRealEstatePurpose)[]
).map((key, index) => {
  return { id: index + 1, value: CorporateOverseasRealEstatePurpose[key] };
});
//string[]のデータ作る
export const CorporateOverseasRealEstatePurposeStrs = CorporateOverseasRealEstatePurposeList.map((data) => data.value);
export const findCorporateOverseasRealEstatePurposeId = (str: string) =>
  CorporateOverseasRealEstatePurposeList.find((data) => data.value === str)?.id;
export const findCorporateOverseasRealEstatePurposeName = (index: number) =>
  CorporateOverseasRealEstatePurposeList.find((data) => data.id === index)?.value;

//投資家区分
export enum InvestorCategoryInfo {
  ListedCompany = '上場法人',
  ForeignCompany = '外国法人',
  Capital500million = '資本金5億以上の株式会社',
  SpecialCompany = '適格機関投資家ではない金融商品取引業者または特例業務届出者である法人',
  Other = '上記のいずれでもない',
}
//{ id: number; value: string }[]のデータ作る
const InvestorCategoryInfoList: CommonData[] = (
  Object.keys(InvestorCategoryInfo) as (keyof typeof InvestorCategoryInfo)[]
).map((key, index) => {
  return { id: index + 1, value: InvestorCategoryInfo[key] };
});
//string[]のデータ作る
export const InvestorCategoryInfoStrs = InvestorCategoryInfoList.map((data) => data.value);
export const findInvestorCategoryInfoId = (str: string) =>
  InvestorCategoryInfoList.find((data) => data.value === str)?.id;
export const findInvestorCategoryInfoName = (index: number) =>
  InvestorCategoryInfoList.find((data) => data.id === index)?.value;

//投資家取り扱い
export enum InvestorCategory {
  GeneralInvestor = '一般投資家',
  SpecificInvestor = '特定投資家',
}
//{ id: number; value: string }[]のデータ作る
const InvestorCategoryList: CommonData[] = (Object.keys(InvestorCategory) as (keyof typeof InvestorCategory)[]).map(
  (key, index) => {
    return { id: index + 1, value: InvestorCategory[key] };
  },
);
export const InvestorCategoryStrs = InvestorCategoryInfoList.map((data) => data.value);

//決算月あれこれ
//リスト名
enum SettlementMonth {
  Jan = '1月',
  Feb = '2月',
  Mar = '3月',
  Apr = '4月',
  May = '5月',
  Jun = '6月',
  Jul = '7月',
  Aug = '8月',
  Sep = '9月',
  Oct = '10月',
  Nov = '11月',
  Dec = '12月',
}
//{ id: number; value: string }[]のデータ作る
const SettlementMonthList: CommonData[] = (Object.keys(SettlementMonth) as (keyof typeof SettlementMonth)[]).map(
  (key, index) => {
    return { id: index + 1, value: SettlementMonth[key] };
  },
);
//string[]のデータ作る
export const SettlementMonthStrs = SettlementMonthList.map((data) => data.value);
export const findSettlementMonthId = (str: string) => SettlementMonthList.find((data) => data.value === str)?.id;
export const findSettlementMonthName = (index: number) => SettlementMonthList.find((data) => data.id === index)?.value;

//決算日あれこれ
//リスト名
enum SettlementDay {
  First = '1日',
  Second = '2日',
  Third = '3日',
  Fourth = '4日',
  Fifth = '5日',
  Sixth = '6日',
  Seventh = '7日',
  Eighth = '8日',
  Ninth = '9日',
  Tenth = '10日',
  Eleventh = '11日',
  Twelfth = '12日',
  Thirteenth = '13日',
  Fourteenth = '14日',
  Fifteenth = '15日',
  Sixteenth = '16日',
  Seventeenth = '17日',
  Eighteenth = '18日',
  Nineteenth = '19日',
  Twentieth = '20日',
  TwentyFirst = '21日',
  TwentySecond = '22日',
  TwentyThird = '23日',
  TwentyFourth = '24日',
  TwentyFifth = '25日',
  TwentySixth = '26日',
  TwentySeventh = '27日',
  TwentyEighth = '28日',
  TwentyNinth = '29日',
  Thirtieth = '30日',
  Last = '末日',
}
//{ id: number; value: string }[]のデータ作る
const SettlementDayList: CommonData[] = (Object.keys(SettlementDay) as (keyof typeof SettlementDay)[]).map(
  (key, index) => {
    return { id: index + 1, value: SettlementDay[key] };
  },
);
//string[]のデータ作る
export const SettlementDayStrs = SettlementDayList.map((data) => data.value);
export const findSettlementDayId = (str: string) => SettlementDayList.find((data) => data.value === str)?.id;
export const findSettlementDayName = (index: number) => SettlementDayList.find((data) => data.id === index)?.value;

//紹介者あれこれ
//リスト名
enum IntroductionConfirmation {
  Accepted = '紹介を受けた',
  NotAccepted = '紹介は受けていない',
  Unknown = '不明',
}
//{ id: number; value: string }[]のデータ作る
const IntroductionConfirmationList: CommonData[] = (
  Object.keys(IntroductionConfirmation) as (keyof typeof IntroductionConfirmation)[]
).map((key, index) => {
  return { id: index + 1, value: IntroductionConfirmation[key] };
});
//string[]のデータ作る
export const IntroductionConfirmationStrs = IntroductionConfirmationList.map((data) => data.value);
export const findIntroductionConfirmationId = (str: string) =>
  IntroductionConfirmationList.find((data) => data.value === str)?.id;

export enum ApplySymbolRequestType {
  Confirm = 0,
  Apply,
}

//職業
//リスト名
export enum Occupation {
  CompanyEmployee = '会社役員／団体役員',
  SelfEmployed = '自営業／個人事業主',
  CompanyStaff = '会社員／団体職員',
  PublicServant = '公務員',
  Homemaker = '専業主婦／主夫',
  RetiredOrUnemployed = '退職された方／無職の方',
  PartTimeOrContract = 'パート／アルバイト／派遣社員／契約社員',
  Student = '学生',
  Other = 'その他',
}
//{ id: number; value: string }[]のデータ作る
const OccupationList: CommonData[] = (Object.keys(Occupation) as (keyof typeof Occupation)[]).map((key, index) => {
  return { id: index + 1, value: Occupation[key] };
});
//string[]のデータ作る
export const OccupationStrs = OccupationList.map((data) => data.value);
export const findOccupationId = (str: string) => OccupationList.find((data) => data.value === str)?.id;
export const findOccupationName = (index: number) => OccupationList.find((data) => data.id === index)?.value;

//個人 投資目的あれこれ
//リスト名
export enum DomesticRealEstatePurpose {
  ShisanHozen = '資産保全',
  ShisanUnyo = '資産運用',
  Other = 'その他',
}
//{ id: number; value: string }[]のデータ作る
const DomesticRealEstatePurposeList: CommonData[] = (
  Object.keys(DomesticRealEstatePurpose) as (keyof typeof DomesticRealEstatePurpose)[]
).map((key, index) => {
  return { id: index + 1, value: DomesticRealEstatePurpose[key] };
});
//string[]のデータ作る
export const DomesticRealEstatePurposeStrs = DomesticRealEstatePurposeList.map((data) => data.value);
export const findDomesticRealEstatePurposeId = (str: string) =>
  DomesticRealEstatePurposeList.find((data) => data.value === str)?.id;
export const findDomesticRealEstatePurposeName = (index: number) =>
  DomesticRealEstatePurposeList.find((data) => data.id === index)?.value;

//個人 投資目的（適合性チェック用）
//リスト名
export enum PersonalPurposeCompatibility {
  ShisanUnyo = '資産運用',
  ShikinShokei = '資産承継',
}
//{ id: number; value: string }[]のデータ作る
const PersonalPurposeCompatibilityList: CommonData[] = (
  Object.keys(PersonalPurposeCompatibility) as (keyof typeof PersonalPurposeCompatibility)[]
).map((key, index) => {
  return { id: index + 1, value: PersonalPurposeCompatibility[key] };
});
//string[]のデータ作る
export const PersonalPurposeCompatibilityStrs = PersonalPurposeCompatibilityList.map(
  (data) => data.value,
);
export const findPersonalPurposeCompatibilityId = (str: string) =>
  PersonalPurposeCompatibilityList.find((data) => data.value === str)?.id;
export const findPersonalPurposeCompatibilityName = (index: number) =>
  PersonalPurposeCompatibilityList.find((data) => data.id === index)?.value;

//法人 投資目的（適合性チェック用）
//リスト名
export enum CorporatePurposeCompatibility {
  ZaimuSenryaku = '財務戦略',
  ShikinUnyo = '資金運用',
  Other = 'その他',
}
//{ id: number; value: string }[]のデータ作る
const CorporatePurposeCompatibilityList: CommonData[] = (
  Object.keys(CorporatePurposeCompatibility) as (keyof typeof CorporatePurposeCompatibility)[]
).map((key, index) => {
  return { id: index + 1, value: CorporatePurposeCompatibility[key] };
});
//string[]のデータ作る
export const CorporatePurposeCompatibilityStrs = CorporatePurposeCompatibilityList.map(
  (data) => data.value,
);
//「その他」以外のstring[]のデータ作る
export const CorporatePurposeCompatibilityStrsExcludeOther = CorporatePurposeCompatibilityList
  .filter((data) => data.value !== CorporatePurposeCompatibility.Other)
  .map((data) => data.value);
export const findCorporatePurposeCompatibilityId = (str: string) =>
  CorporatePurposeCompatibilityList.find((data) => data.value === str)?.id;
export const findCorporatePurposeCompatibilityName = (index: number) =>
  CorporatePurposeCompatibilityList.find((data) => data.id === index)?.value;


export enum InvestmentRange {
  OverThreeHundredMillion = '3億円以上',
  OneToThreeHundredMillion = '1億円以上 3億円未満',
  LessThanOneHundredMillion = '1億円未満',
}

export enum AmountRange {
  OverThirtyMillion = '3,000万円以上',
  TenToThirtyMillion = '1,000万円以上 3,000万円未満',
  LessThanTenMillion = '1,000万円未満',
}

export const convertEnumToMultiSelectionAnswer = <T extends Record<string, string>>(
  enumObj: T,
): MultiSelectionAnswer[] => {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key))) // 数値の逆引きキー（number enum の場合）を除外
    .map((key, index) => ({
      value: index + 1,
      label: enumObj[key as keyof T] as string,
    }));
};

//法人口座か個人口座か
export enum AccountType {
  Corporate = 1,
  Personal,
}

export enum ChangeAccountInfoExecuteType { 
  All = 1,
  DomesticRealEstateApplication = 2,
}

export enum FatcaStatus {
  None = 0,
  No,
  Yes,
  UsCompany,  
  JapaneseCompany,
}

//案件申込タイプ
export enum ApplyAssetType {
  ITExplanation = 1,
  DomesticRealEstate,
  OverseasRealEstate,
  LeaseFund,
}

export enum IssuanceDocumentType {
  AnonymousAssociationContractAssignmentAgreement = 1,//匿名組合契約地位譲渡契約書
  ContractConclusionDeliveryDocument,//契約締結時交付書面
  TransferRequestForm,//振込依頼書
  JournalEntryExample,//仕訳例
  InformationPackage,//InformationPackage
  PreContractDeliveryDocument,//契約締結前交付書面
  PreContractDeliveryDocumentSimplified,//契約締結前交付書面_簡易版
  SalesContract,//売買契約書
  TransferConsentRequest,//譲渡承諾請求書
  TransferConsent,//譲渡承諾書
}

export const OverseasKeys = [
  "Kinyugyo",
  "KensetsuGyo",
  "SeizouGyo",
  "JyohoTsushinGyo",
  "UnyuGyo",
  "OroshiUriKouriGyo",
  "FudousanBuppinChintaiGyo",
  "SenmonGijyutuServiceGyo",
  "ShukuhakuInshokuServiceGyo",
  "SeikatukanrenServiceGorakuGyo",
  "KyouikuGakushusienGyo",
  "IryoFukushi",
  "Service",
  "Sonohoka",
] as const;

export type OverseasKey = typeof OverseasKeys[number];

export const OverseasRealEstateBusinessContentText = {
  Kinyugyo: "⓪金融業・保険業",
  KensetsuGyo: "①建設業",
  SeizouGyo: "②製造業",
  JyohoTsushinGyo: "③情報通信業",
  UnyuGyo: "④運輸業",
  OroshiUriKouriGyo: "⑤卸売業・小売業",
  FudousanBuppinChintaiGyo: "⑥不動産業・物品賃貸業",
  SenmonGijyutuServiceGyo: "⑦専門・技術サービス業",
  ShukuhakuInshokuServiceGyo: "⑧宿泊業・飲食サービス業",
  SeikatukanrenServiceGorakuGyo: "⑨生活関連サービス業・娯楽業",
  KyouikuGakushusienGyo: "⑩教育・学習支援業",
  IryoFukushi: "⑪医療・福祉",
  Service: "⑫サービス業(他に分類されないもの)",
  Sonohoka: "⑬その他",
} as const satisfies Record<OverseasKey, string>;

export const OverseasRealEstateBusinessContentData = {
  KensetsuGyo: 1,
  SeizouGyo: 2,
  JyohoTsushinGyo: 3,
  UnyuGyo: 4,
  OroshiUriKouriGyo: 5,
  FudousanBuppinChintaiGyo: 6,
  SenmonGijyutuServiceGyo: 7,
  ShukuhakuInshokuServiceGyo: 8,
  SeikatukanrenServiceGorakuGyo: 9,
  KyouikuGakushusienGyo: 10,
  IryoFukushi: 11,
  Service: 12,
  Sonohoka: 13,
  Kinyugyo: 14, // 表示は0番目だが値は14
} as const satisfies Record<OverseasKey, number>;

export type OverseasValue = typeof OverseasRealEstateBusinessContentData[OverseasKey];

export const OverseasOptions = OverseasKeys.map((k) => ({
  key: k,
  label: OverseasRealEstateBusinessContentText[k],
  value: OverseasRealEstateBusinessContentData[k],
}));

//{ id: number; value: string }[]のデータ作る
const OverseasRealEstateBusinessContentList: CommonData[] = OverseasKeys.map((k) => ({
  id: OverseasRealEstateBusinessContentData[k],
  value: OverseasRealEstateBusinessContentText[k],
}));
//string[]のデータ作る
export const OverseasRealEstateBusinessContentStrs = OverseasRealEstateBusinessContentList.map((data) => data.value);
export const findOverseasRealEstateBusinessContentId = (str: string) =>
  OverseasRealEstateBusinessContentList.find((data) => data.value === str)?.id;
export const findOverseasRealEstateBusinessContentName = (index: number) =>
  OverseasRealEstateBusinessContentList.find((data) => data.id === index)?.value;